export const getPaymentTableHeaders = (useDollars) => ({
  select: "SELECCIONAR",
  importer: "IMPORTADOR",
  volante: "Nº DE VOLANTE",
  paymentType: "TIPO DE PAGO",
  status: "RESTRICCIONES",
  retirement: "RETIRO",
  rucId: "RAZÓN SOCIAL FACTURABLE",
  electronicFacNum: "NRO DE SERIE",
  amount: `MONTO (${useDollars ? "DÓLARES" : "SOLES"})`,
  exportPdf: "EXPORTAR A PDF",
  statusPreInvoice: "ESTADO",
  actions: "ACCIONES",
});

export const ITEMS_PER_PAGE = 8;

export const PAYMENT_TABLE_MODAL_STATES = {
  disabled: 0,
  paymentComment: 1,
  paymentDeletion: 2,
  comment: 3,
};
